import styled from "styled-components";
import SVG from "react-inlinesvg";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    margin-top: 75px;
    width: -webkit-fill-available;
    @media (min-width: 720px) {
        margin-left: 176px;
        margin-top: 0px;
    }
    @media (orientation: landscape) and (max-width: 1200px){
        display: none;
    }
`;

export const FrameContainer = styled.div`
    align-items: flex-start;
    display: flex;
    justify-content: flex-start;

    @media (min-width: 720px) {
        gap: 15px;
        height: ${props => props.$allowEdit ? '100%' : '92%'};
        padding-top: 150px;
        margin-top: 20px;
    }

    @media (min-width: 768px) and (max-width: 1024px) {
        margin-top: 60px;
    }
`;

export const HeaderContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: space-between;
    padding: 20px;
    @media (min-width: 720px) {
        display: flex;
        height: 160px;
        left: 176px;
        padding: 20px 80px 20px 0px;
        position: fixed;
        right: 0;
    }

    #edit{
        display: flex;
        width: 100%;
    }

    .configuration-bar {
        display: flex;
        flex-direction: column;
        gap: 10px;
        justify-content: center;
        width: 70%;
        
        @media (min-width: 720px) {
            flex-direction: row;
            justify-content: space-between;
            width: 100%;
        }
    }
`;

export const RowContainer = styled.div`
    align-items: center;
    display: flex;
    gap: 18px;
    justify-content: center;
`;

export const ContentContainer = styled.div`
    align-items: center;
    background: #FFFFFF;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    max-height: 80%;
    min-width: 380px;
    padding: 15px;
    position: relative;
    &::-webkit-scrollbar {
        width : 7px;
    }
    &::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #aaa
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
`;

export const SaveContainer = styled.div`
    align-items: center;
    display: none;
    gap: 18px;
    justify-content: center;
    @media (min-width: 720px) {
        display : flex;
        width: 20%;
    }
`

export const CancelButton = styled.button`
    align-items: center;
    background: transparent;
    border: 1px solid #FF3939;
    border-radius: ${props => props.$borderRadius};
    color: #FF3939;
    cursor: pointer;
    display: flex;
    font: inherit;
    font-weight: 900;
    height: 60px;
    justify-content: center;
    line-height: normal;
    outline: none;
    padding: 20px 20px 20px 20px;
    transition: 1s;
    width: ${props=>props.$width ? props.$width : 'fit-content'};
    &:hover {
        background: #FF3939;
        color: #fff;
    }
`;

export const ConfigSelectorContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 12px;
    justify-content: center;
    width: 80%;
`;

export const ConfigsContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 35px;
    justify-content: flex-start;
    overflow: auto;
    width: 100%;
    &::-webkit-scrollbar {
        width : 7px;
    }
    &::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #aaa
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
`;

export const LayoutButton = styled.button`
    background: ${props => props.$select ? '#F6F6F6' : 'transparent'};
    border: ${props => props.$select ? '1px solid #3C9' : 'none'};
    border-radius: 10px;
    color: #3C9;
    cursor: pointer;
    display: flex;
    gap: 10px;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-block: 20px;
    margin-inline: 5px;
    max-height: 72px;
    max-width: 220px;
    outline:none;
    overflow: hidden;
    overflow-x: auto;
    padding: 20px 20px 20px 20px;
    transition: 1s;
    white-space: nowrap;
    width: fit-content;
    &::-webkit-scrollbar {
        height : 8px;
    }
    &::-webkit-scrollbar-thumb {
        background: #CCCCCC;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #AAAAAA
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
    &:hover {
        background: #3C9;
        color: #FFFFFF;
    }
    &:disabled{
        cursor: no-drop;
    }
`;

export const LayoutInput = styled.input`
    align-items: center;
    background: ${props => props.$select ? '#F6F6F6' : 'transparent'};
    border: ${props => props.$select ? '1px solid #3C9' : 'none'};
    border-radius: 10px;
    color: #3C9;
    display: flex;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    gap: 10px;
    justify-content: center;
    line-height: normal;
    margin-block: 20px;
    margin-inline: 5px;
    outline:none;
    padding: 20px 20px 20px 20px;
    transition: 1s;
    width: fit-content;
`;

export const AddButton = styled.button`
    align-items: center;
    background: #3C9;
    border: 0.743px solid #3C9;
    border-radius: 50%;
    color: #FFFFFF;
    cursor: pointer;
    display: flex;
    font: inherit;
    font-weight: 900;
    height: 55px;
    justify-content: center;
    line-height: normal;
    outline: none;
    padding: 20px 20px 20px 20px;
    transition: 1s;
    width: 55px;
    &:hover {
        background: #fff;
        color: #3C9;
    }
    &:disabled{
        background: #A3A3A3;
        color: #fff;
        cursor: no-drop;
    }
`;

export const LayoutContainer = styled.div`
    display: flex;
    border-radius: 5px;
    // border-top: ${props => props.$select ? '1px solid rgba(0, 0, 0, 0.10)' : 'none'};
    // border-left: ${props => props.$select ? '1px solid rgba(0, 0, 0, 0.10)' : 'none'};
    // border-right: ${props => props.$select ? '1px solid rgba(0, 0, 0, 0.10)' : 'none'};
`;

export const FloatingButton = styled.button`
    background: #3C9;
    border: 0.743px solid #3C9;
    border-radius: 10px;;
    color: #F2F2F2;
    cursor: pointer;
    display: flex;
    gap: 10px;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding: 8px;
    outline: none;
    position: fixed;
    right: 20px;
    text-align: center;
    top: 120px;
    transition: 1s;
    z-index: 1050;
    @media (min-width: 720px) {
        bottom: 1%;
        right: 5%;
        top: auto;
    }
    @media(min-width: 1281px){
        font-size: 18px;
        padding: 15px;
    }
    @media (orientation: landscape) and (max-width: 1200px){
        bottom: 120px;
        right: 25px;
    }
`;

export const CustomMobileButton = styled.button`
    align-items: center;
    background: #3C9;
    border: 0.743px solid #3C9;
    border-radius: 50%;
    bottom: 110px;
    color: #FFFFFF;
    cursor: pointer;
    display: flex;
    font: inherit;
    font-weight: 900;
    height: 50px;
    justify-content: center;
    line-height: normal;
    outline: none;
    padding: 20px 20px 20px 20px;
    position: fixed;
    right: 20px;
    transition: 1s;
    width: 50px;
    z-index: 9;
    &:hover {
        background: #fff;
        color: #3C9;
    }
    @media (min-width: 720px) {
        display: none;
    }
`;

export const CustomButton = styled.button`
    align-items: center;
    background: #FFFFFF;
    border: 1px solid #006560;
    border-radius: 10px;
    color: #333;
    cursor: ${(props) => (props.$visibility ? 'pointer' : 'auto')};
    display: ${(props) => (props.$visibility ? 'flex' : 'none')};
    font: inherit;
    font-size: 13px;
    font-weight: 600;
    gap: 10px;
    justify-content: center;
    line-height: normal;
    opacity: ${(props) => (props.$visibility ? '1' : '0')};
    outline: none;
    padding: 10px 8px;
    transition: 0.5s;
    z-index: 9;
    &:hover {
        background: #006560;
        color: #fff;
    }
    &:disabled{
        cursor: no-drop;
    }
    @media (min-width: 720px) {
        display: flex;
    }
    @media (min-width: 1281px){
        font-size: 18px;
        padding: 20px 20px 20px 20px;
    }
`;

export const SelectIndicator = styled.img`
    align-items: flex-start;
    display: flex;
    height: 100%;
    justify-content: flex-start;
`;

export const CustomButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    justify-content: center;
    width: 100%;
`;

export const Header = styled.div`
    align-items: flex-end;
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

export const RowHeader = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 10px;
    justify-content: space-between;
`;

export const SaveEditMobile = styled.div`
    align-items: center;
    background-color: #3C9;
    border-radius: 5px;
    bottom: 25px;
    color: #FFFFFF;
    cursor: pointer;
    display: flex;
    height: ${(props) => (props.$show ? '81px' : '0px')};
    justify-content: center;
    padding: ${(props) => (props.$show ? '10px' : '0px')};
    position: fixed;
    right: 25px;
    transition: 1s;
    visibility: ${(props) => (props.$show ? 'visible' : 'hidden')};
    width: ${(props) => (props.$show ? '81px' : '0px')};
    z-index: 999999;
    @media (min-width: 720px) {
        display: none;
    }
`;

export const CancelEditMobile = styled.div`
    align-items: center;
    background: #FF3939;
    border: 0.743px solid #FF3939;
    border-radius: 50%;
    bottom: 110px;
    color: #FF3939;
    cursor: pointer;
    display: flex;
    font: inherit;
    font-weight: 900;
    height: ${(props) => (props.$show ? '50px' : '0px')};
    justify-content: center;
    line-height: normal;
    outline: none;
    position: fixed;
    padding: 20px 20px 20px 20px;
    padding: ${(props) => (props.$show ? '10px' : '0px')};
    right: 20px;
    transition: 1s;
    visibility: ${(props) => (props.$show ? 'visible' : 'hidden')};
    width: ${(props) => (props.$show ? '50px' : '0px')};
    z-index: 100;
    @media (min-width: 720px) {
        display: none;
    }
    @media (min-width: 720px) {
        display: none;
    }
`;

export const EditImage = styled.img`
    display: flex;
    transition: 0.5s;
`;

export const DeleteLayoutButton = styled.button`
    align-self: center;
    background: transparent;
    border: none;
    border-radius: 10px;
    box-shadow: none;
    cursor: pointer;
    display: flex;
    outline: none;
    padding: 5px;
    transition: 0.2s;
    user-select: none;

    -moz-user-select: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
    &:hover {
        background: #FF3939;
        color: #fff;
    }
`;

export const NumberInput = styled.input`
    align-items: center;
    background: #FFFFFF;
    border: 1.14px solid #C4C4C4;
    border-radius: 3.802px;
    box-shadow: 1.52061px 1.52061px 3.80152px 0px rgba(0, 0, 0, 0.40) inset;
    color: #333;
    display: flex;
    font-size: 15px;
    font-style: normal;
    font-weight: 600; 
    height: 24px;
    justify-content: center;
    line-height: 0;
    outline: none;
    text-align: center;
    width: 48px;
    &::-webkit-inner-spin-button{
        -webkit-appearance: none;
    }
`;

export const AlarmText = styled.span`
    color: #333;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 0%; /* 0px */
    width: 73px;
`;

export const ModalContainer = styled.div`
    align-items: center;
    background: rgba(80, 80, 80, 0.7);
    display: ${({$Active}) => ($Active ? 'flex' : 'none')};
    height: 100vh;
    justify-content: center;
    position: fixed;
    transition: ease-out 0.8s;
    width: 100%;
    z-index: 9999;
`;

export const ModalTitleContainer = styled.h3`
    color: #333;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-bottom: 20px;
    text-align: center;
`;

export const ComandsContainer = styled.div`
    margin-top: 80px;
    overflow: auto;
    padding-bottom: 30px;
    width: 320px;
    &::-webkit-scrollbar {
        width : 5px;
    }
    &::-webkit-scrollbar-thumb {
        background: #CCCCCC;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #AAAAAA
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
`;

export const ModalTitle = styled.div`
    display: flex;
    justify-content: center;
    position: fixed;
`

export const SendImage = styled.img`
    height: 20px;
    width: 20px;
    @media (min-width: 1281px) {
        height: 24px;
        width: 24px;
    }
`;

export const LastUpdateContainer = styled.div`
    align-items: center;
    display: flex;
    gap: 10px;
    justify-content: flex-end;

    @media (min-width: 720px) {
        flex-direction: row;
        gap: 20px;
    }

    div.date-time {
        align-items: flex-end;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
`;

export const LastUpdateIcon = styled.img`
    height: 16px;
    width: 16px;
`;

export const LastUpdateText = styled.span`
    align-items: center;
    color: #333;
    display: flex;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    gap: 5px;
    justify-content: center;
    line-height: normal;
    text-align: center;
    white-space: nowrap;

    @media (min-width: 720px) {
        font-size: 12px;
    }
    @media (min-width: 1281px) {
        font-size: 16px;
    }
`;

export const CardsContainer = styled.div`
    display: grid;
    gap: 20px;
    grid-auto-flow: column;
    grid-template-columns: repeat(4, 1fr);
    // min-width: 1240px;
    mask-image: linear-gradient(to left, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1) 5%);
    min-height: 358px;
    overflow: auto;
    overflow-y: clip;
    padding-right: 5%;
    // &::-webkit-scrollbar {
    //     height : 10px;
    // }
    // &::-webkit-scrollbar-thumb {
    //     background: #ccc;
    //     border-radius: 5px;
    // }
    // &::-webkit-scrollbar-thumb:hover {
    //     background-color: #aaa
    // }
    // &::-webkit-scrollbar-track {
    //     background: transparent;
    // }
    // &::-webkit-scrollbar-button {
    //     display: none;
    // }
`;

export const DetailsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    height: 100%;
    overflow: auto;
    padding-right: 80px;
    width: 100%;
    &::-webkit-scrollbar {
        height: 5px;
        width : 5px;
    }
    &::-webkit-scrollbar-thumb {
        background: rgb(217, 217, 217);
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #aaa
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
`;

export const CardIndicator = styled.div`
    align-items: center;
    background: #006560;
    border-radius: 5px;
    box-shadow: 0px 1.52px 1.52px 0px rgba(0, 0, 0, 0.25);
    color: #FFFFFF;
    display: flex;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    gap: 10px;
    justify-content: center;
    line-height: normal;
    max-height: 87px;
    padding: 8px 28px;
    text-align: center;
    width: fit-content;
    z-index: 999;
    @media (min-width: 720px) {
        font-size: 28px;
        padding: 12px 40px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        font-size: 14px;
        padding: 8px 28px;
    }
`;

export const FixedIcon = styled(SVG)`
    align-self: center;
    height: 15px;
    rotate: ${(props) => (props.$inverter? '180deg' : '0deg')};
    width: 15px;
    & path {
        fill: ${({ fill }) => fill};
    }
    @media (min-width: 720px) {
        height: 20px;
        width: 20px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        height: 15px;
        width: 15px;
    }
`;

export const DetailsLayout = styled.div`
    display: flex;
    flex-direction: column;
    gap: 25px;
    height: 100%;
    width: ${props =>(props.$IsGeral? '100%': '330px')};
    @media (orientation: landscape) and (max-width: 1200px){
        display: ${props =>(props.$show? 'flex' : 'none')};
        width: 280px;
    }
`;

export const AlarmIndicator = styled.div`
    align-items: center;
    background: ${props=> (props.color)};
    border-radius: 5.533px;
    bottom: 0;
    display: flex;
    height: 11px;
    justify-content: center;
    position: absolute;
    width: 100%;
`;

export const UnderArrowContainer = styled.img`
    height: 10px;
    width: 10px;
`;

export const ContainerDetailMobile = styled.div`
    background: transparent;
    display: none;
    flex-direction: column;
    gap: 15px;
    height: 100%;
    padding: 10px;
    width: 100%;
    @media (min-width: 1080px) {
        margin-left: 176px;
    }
    @media (orientation: landscape) and (max-width: 1200px){
        display: flex;
    }

    #selects-landscape {
        display: flex;
    }
`;

export const Bodymobile = styled.div`
    background: transparent;
    display: ${(props)=> props.$visibility ? 'none' : 'flex'};
    gap: 15px;
    height: 92%;
    min-height: 360px;
    padding: 10px;
    /* padding-top: 45px; */
    position: relative;
    width: 100%;
    @media (orientation: landscape) and (max-width: 1200px){
        height: 100%;
    }
`;

export const HeaderMobile = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 98%;
    z-index: 999;

    div#selects-landscape{
        display: flex;
        gap: 20px;

        @media (orientation: landscape) and (max-width: 1200px){
            gap: 12px;
        }
    }
`;

export const TopGraph = styled.div`
    align-items: end;
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 60%;
`;

export const MobileRightSide = styled.div`
    display: flex;
    flex-direction: column ;
    gap: 10px;
`;

export const ContainerLeft = styled.div`
    display: flex;
    flex-direction: row;
    gap: 15px;    
`;

export const CardIndicatorContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
`;

export const CardPlaceHolder = styled.button`
    background: #006560;
    border: none;
    border-radius: 4.992px;
    color: #FFFFFF;
    font-size: 10px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    padding: 8px 15px;
    text-align: center;
`;

export const CardsPlace = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const ContainerUpdate = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 6px;
`;

export const LayoutSelect = styled.select`
    background: transparent;
    border: 1px solid #006560;
    border-radius: 5px;
    color: #333;
    display: flex;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    max-width: 150px;
    outline: none;
    padding: 4px 8px;
    @media (min-width: 1281px) {
        font-size: 18px;
    }
`

export const StyledOption = styled.option`
    color: #333;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    @media (min-width: 1281px) {
        font-size: 18px;
    }
`

export const ColumnHeader = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 10px 0 40px;

    div.date-time {
        align-items: flex-end;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
`;

export const SelectContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    /* width: 100%; */
    @media (min-width: 1080px) {
        flex-direction: row;
    }
    @media (orientation: landscape) and (max-width: 1200px){
        flex-direction: column;
    }
`